import * as _ from 'lodash';
import moment, { duration } from 'moment';
import {limitTo, timestamp, truncDate} from './date.util';
import { getShiftSessionsTimeBounds, getShiftSessionTimeBounds, getShiftTimeBoundsByTimestamp, inShiftBounds, inShiftSessionBounds, isFromPreviousDayShift, isFromPreviousDayShiftSession } from './shift.util';
const SERIE_TYPE = {
    LINE: 'line',
    BAR: 'column'
};
export interface Sample {
    timestamp: string;
    units_time: string;
    units: number;
    machine_id: number;
    sensor_id: number;
    shift_id: number;
    shift_session_id?: number;
    company_id?: number;
}

export interface MachineStatsInterface {
    shifts: any;
    units: number;
    machine: any;
    samples: Sample[];
    maxVel: number;
    meanVel: number;
    vel: number;
    expectedMeanVelAccumulated: number;
    expectedVelAccumulated: number;
    elapsedMinutes: number;
    partialElapsedMinutes: number;
    currentMaxProduction: number;
    partialMaxProduction: number;
    performance: number;
    partialPerformance: number;
    productionTime: string;
    productionMinutes: number;
    stoppedTime: string;
    stoppedMinutes: number;
    stoppedPercentStr: string;
    effectivePercentStr: string;
    shiftDuration: number;
    shiftPartialDuration: number;
    packagingUnit: string;
}

export interface MachineStatsObj {
    [machineId: number]: MachineStatsInterface;
}

export class MachineStats implements MachineStatsInterface {
    shifts: any;
    units: number;
    machine: any;
    samples: Sample[];
    maxVel: number;
    meanVel: number;
    vel: number;
    expectedMeanVelAccumulated: number;
    expectedVelAccumulated: number;
    elapsedMinutes: number;
    partialElapsedMinutes: number;
    currentMaxProduction: number;
    partialMaxProduction: number;
    performance: number;
    partialPerformance: number;
    productionTime: string;
    productionMinutes: number;
    stoppedTime: string;
    stoppedMinutes: number;
    stoppedPercentStr: string;
    effectivePercentStr: string;
    shiftDuration: number;
    shiftPartialDuration: number;
    packagingUnit: string;
    constructor() {
        this.units = 0;
        this.samples = [];
        this.shifts = {};
        this.meanVel = 0;
        this.vel = 0;
        this.expectedMeanVelAccumulated = 0;
        this.expectedVelAccumulated = 0;
        this.packagingUnit = 'unidades';
    }
}

export interface PlantStatsInterface {
    accumulated: number;
    elapsedMinutes: number;
    partialElapsedMinutes: number;
    currentMaxProduction: number;
    partialMaxProduction: number;
    performance: number;
    partialPerformance: number;
    productionTime: string;
    productionMinutes: number;
    stoppedTime: string;
    stoppedMinutes: number;
    stoppedPercentStr: string;
    effectivePercentStr: string;
    shiftDuration: number;
    shiftPartialDuration: number;
    entryPlantAccumulated: number;
    outputPlantAccumulated: number;
    expectedMeanVelAccumulated: number;
    expectedVelAccumulated: number;
    vel: number;
    meanVel: number;
    outMachineList: any[];
}

export class PlantStats implements PlantStatsInterface {
    accumulated = 0;
    elapsedMinutes = 0;
    partialElapsedMinutes = 0;
    currentMaxProduction = 0;
    partialMaxProduction = 0;
    performance = 0;
    partialPerformance = 0;
    productionTime = '00:00';
    productionMinutes = 0;
    stoppedTime = '00:00';
    stoppedMinutes = 0;
    stoppedPercentStr: string;
    effectivePercentStr: string;
    shiftDuration = 0;
    shiftPartialDuration = 0;
    entryPlantAccumulated = 0;
    outputPlantAccumulated = 0;
    expectedMeanVelAccumulated = 0;
    expectedVelAccumulated = 0;
    vel = 0;
    meanVel = 0;
    outMachineList: any[];

    constructor() {
    }
}

export function colorGenerator() {
    let colorIdx = 0;
    const colorPalette =
    // ['#19439c', '#3773b5', '#5aa5c9', '#8fd7d2', '#ffffa8', '#ffbb71', '#f07862', '#cd3750', '#93003a'];
    ['#fd7f6f', '#7eb0d5', '#b2e061', '#bd7ebe', '#ffb55a', '#ffee65', '#beb9db', '#fdcce5', '#8bd3c7'];
    // ["#b30000", "#7c1158", "#4421af", "#1a53ff", "#0d88e6", "#00b7c7", "#5ad45a", "#8be04e", "#ebdc78"];
    // ["#e60049", "#0bb4ff", "#50e991", "#e6d800", "#9b19f5", "#ffa300", "#dc0ab4", "#b3d4ff", "#00bfa0"];
    return {
        generate: () => {
            const color = colorPalette[colorIdx];
            colorIdx += 1;
            if (colorIdx == colorPalette.length) { colorIdx = 0; }
            return color;
        },
        reset: () => {
            colorIdx = 0;
        },
        random: () => {
            return colorPalette[Math.floor(Math.random() * colorPalette.length)];
        }
    };
}

function minutesToStr(minutes) {
    // let date = new Date();
	const mdate = moment.duration(minutes, 'minutes');

 const hour = mdate.get('hours');
 const minute = mdate.get('minutes');
	const days = mdate.get('days');

	const text = `${days > 0 ? days + ' dias ' : ''} ${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
		// console.log(`minutes to string ${minutes} a ${text}`)
	return text;
}

export function inTimeRange(data: any[], t1: Date, t2: Date) {
    t1 = new Date(t1);t1.setSeconds(0,0);
    t2 = new Date(t2);t2.setSeconds(0,0);
    const st = t1.getTime();
    const et = t2.getTime();
    return data.filter(sample => {
        const sampleDate = new Date(sample.timestamp);
        sampleDate.setSeconds(0, 0);
        const sampleTime = sampleDate.getTime();
        if(!(sampleTime >= st && sampleTime <= et))
            console.log(`stest ${sampleDate.toLocaleString('sv')} >= ${t1.toLocaleString('sv')} && ${sampleDate.toLocaleString('sv')} <= ${t2.toLocaleString('sv')} == ${sampleTime >= st && sampleTime <= et}`)
        return sampleTime >= st && sampleTime <= et;
    });
}

export function thereIsAProductionLine(machineList) {
    const machine = machineList.find(machine => machine.production_line_id != null && machine.machine_tech_type_id != 5);
    return machine != undefined;
}

export function isLastInProductionLine(machine: any): boolean {
    return machine.is_last_in_production_line == true && machine.machine_tech_type_id != 5;
}

export function getLastInProductionLine(machineList) {
    return machineList.filter(isLastInProductionLine);
}

export function convertUnits(machine: any, value, sensorId) {
    if (typeof value  == 'string' ) { value = parseFloat(value); }
    const sensor = machine.Machine2Sensors.find(sensor => sensor.id == sensorId);
    let data_conversion = machine.data_conversion;
    if (sensor) {
        data_conversion = sensor.data_conversion;
    }
    const convertedValue = Math.round(data_conversion * value * 100) / 100;
    // console.log(`ftest ${machine.id} ${machine.name} con sensor ${sensor?sensor.id:undefined} conversion ${data_conversion}.. valor original ${value} => valor convertido ${convertedValue}`)
    if (isNaN(convertedValue)) {return 0; }
    return convertedValue;
}

export function convertSampleUnit(sample: Sample, machine: any) {
    return convertUnits(machine, sample.units, sample.sensor_id);
}

// Filtra aquellas muestras que esten dentro del rango aceptable.
// Aquellas que sobrepasen el valor máximo quedan en 0.
export function trustySamples(samples: Sample[], machineList: any[]): Sample[] {
	return samples.map(sample => {
		const machine = machineList.find(m => m.id == sample.machine_id);
		if (machine === undefined) {
			// console.log(`No se encuentra maquina con id ${sample.machine_id} en lista `, machineList);
			return sample;
		}
		return Object.assign({}, sample, {
			units: (machine.vel_max && sample.units > machine.vel_max) ? 0 : sample.units
		});
	});
}

/*
Aplica conversion de unidades de las muestras
*/
export function applySamplesUnitsConversion(samples: Sample[], machineList: any[]) {
    const machineMap = {};
    samples.forEach(sample => {
        if (machineMap[sample.machine_id] == undefined) {
            machineMap[sample.machine_id] = machineList.find(machine => machine.id == sample.machine_id);
        }
        const machine = machineMap[sample.machine_id];
        if (machine == undefined) { return; }
        sample.units = convertSampleUnit(sample, machine);
    });
}

/*
Filtra muestras que correspondan a maquinas productivas. Se define productiva aquella
maquina sensor que es tomada en cuenta para datos estadisticos de productividad.
*/
export function productiveSamples(samples: Sample[], machineList: any[]) {
    const machineMap = {};
    return samples.filter(sample => {
        if (machineMap[sample.machine_id] == undefined) {
            machineMap[sample.machine_id] = machineList.find(machine => machine.id == sample.machine_id);
        }
        const machine = machineMap[sample.machine_id];
        if (machine == undefined) { return false; }
        return isProductive(sample.sensor_id, machine);
    });
}

/*
Filtra muestras que correspondan a maquinas no productivas. Se define productiva aquella
maquina sensor que es tomada en cuenta para datos estadisticos de productividad.
*/
export function nonProductiveSamples(samples: Sample[], machineList: any[]) {
    const machineMap = {};
    return samples.filter(sample => {
        if (machineMap[sample.machine_id] == undefined) {
            machineMap[sample.machine_id] = machineList.find(machine => machine.id == sample.machine_id);
        }
        const machine = machineMap[sample.machine_id];
        if (machine == undefined) { return false; }
        return !isProductive(sample.sensor_id, machine);
    });
}

/*
Define si la relacion maquina2sensor corresponde a un sensor del tipo productivo, es decir
que sea tomado en cuenta para las estadisticas
*/
export function isProductive(sensorId: number, machine: any): boolean {
    const machine2sensor = machine.Machine2Sensors.find(machine2sensor => machine2sensor.id == sensorId);
    if (machine2sensor && machine2sensor.machine_tech_type_id == 5) { return false; } // Se ignoran aquellas maquinas on off para estadisticas
    if (machine.machine_type_id > 5) { return false; } // Se ignoran maquinas no productivas para estadisticas
    return true;
}

/*
Calcula tiempo parcial de duración total teniendo en cuenta la
colación. Resultado en minutos.
*/
function shiftPartialDuration(shift: any): number {
    return shift.shift_duration_minutes - shift.collation_time_minutes
}

//Genera fecha de referencia para calcular tiempos de produccion y detencion respecto al turno y al dia. Se asume que solo se trabaja un dia!
function generateReferenceDate(shift: any, lastSample: Sample): Date{
    const lastDate = new Date(lastSample.timestamp);
    let referenceDate = new Date(shift.et);
    if(shift.et.getDate() != shift.st.getDate() && lastDate.getDate() === shift.st.getDate()){
        referenceDate = new Date(shift.st);
        referenceDate.setHours(23, 59, 59, 999);
    }
    // console.log(`generateReferenceDate: shift.st: ${shift.st.toLocaleString('sv')} shift.et: ${shift.et.toLocaleString('sv')} lastSample: ${lastSample.timestamp} => referenceDate: ${referenceDate.toLocaleString('sv')}`);
    return referenceDate;
}

/*
Calcula tiempo que ha pasado del turno dada una fecha de referencia
sin tomar en cuenta el tiempo de colación
*/
function shiftElapsedTime(shift: any, referenceDate = new Date()): number {
    const elapsedMinutes = (referenceDate.getTime() - shift.st.getTime()) / 1000 / 60;
    return Math.max(0, elapsedMinutes);
}


/*
Retorna el tiempo parcial transcurrido del turno en minutos. Esto es
descontando la cantidad de minutos correspondientes a la colación
respecto al total del turno.
*/
function shiftPartialElapsedTime(shift: any, referenceDate = new Date()): number {
  const elapsedMinutes = shiftElapsedTime(shift, referenceDate);

  if (elapsedMinutes <= 0) return 0;

  const shiftDurationMinutes = Number(shift.shift_duration_minutes || 0);
  const collationMinutes = Number(shift.collation_time_minutes || 0);

  if (shiftDurationMinutes <= 0 || collationMinutes <= 0) {
    return elapsedMinutes;
  }

  const proportionalCollation = Math.min(elapsedMinutes, shiftDurationMinutes) / shiftDurationMinutes * collationMinutes;

  const partialElapsed = elapsedMinutes - proportionalCollation;

  return Math.max(0, partialElapsed);
}

/*
Acumulado máximo actual dada una velocidad máxima de máquina y un tiempo
transcurrido en minutos
*/
function currentMaxAccum(maxVel: number, elapsedTime: number): number {
    return maxVel * elapsedTime;
}

/*
Velocidad máxima en conjunto de una lista de máquinas
*/
function machineGroupMaxVel(machineList: any[]): number {
    return machineList.reduce((prev, curr, idx) => prev + parseInt(curr.vel_max), 0);
}

/*
Acumulado máximo actual para un turno y una lista de máquinas
*/
function shiftCurrentMaxAccum(shift: any, machineList: any[]): number {
    return currentMaxAccum(machineGroupMaxVel(machineList), shiftElapsedTime(shift));
}

/*
Acumulado máximo actual para un turno y una lista de máquinas
teniendo en cuenta el tiempo parcial de colación
*/
function shiftPartialMaxAccum(shift, machineList: any[]): number {
    return currentMaxAccum(machineGroupMaxVel(machineList), shiftPartialElapsedTime(shift));
}

/*
Porcentaje de rendimiento dado una producción y una producción
máxima esperada
*/
function performance(units: number, maxAccumulated: number): number {
    if (!maxAccumulated || maxAccumulated <= 0) return 0;
    return (units / maxAccumulated) * 100;
}

/*
Porcentaje de rendimiento actual de un turno y un listado de
máquinas
*/
function shiftCurrentPerformance(units: number, shift: any, machineList: any[]): number {
    const shiftCurrentMaxAccumulated = shiftCurrentMaxAccum(shift, machineList); // vel max se asume en minutos
    return performance(units, shiftCurrentMaxAccumulated);
}

/*
Porcentaje de rendimiento actual de un turno y un listado de
máquinas teniendo en cuenta el tiempo de colación
*/
function shiftPartialPerformance(units: number, shift: any, machineList: any[]): number {
    const shiftCurrentMaxAccumulated = shiftPartialMaxAccum(shift, machineList); // vel max se asume en minutos
    return performance(units, shiftCurrentMaxAccumulated);
}

/*
Calcula estadisticas por turno
*/
export function statsPerShift(samples: Sample[], shiftList: any[], machineList: any[], wasteList: any[]) {
    const shiftStatList = {};

    samples.forEach(sample => {
        const machineId = sample.machine_id;
        if (shiftStatList[sample.shift_id] == undefined) {
            shiftStatList[sample.shift_id] = {
                machines: {},
                units: 0,
                shift: shiftList.find(s => s.id == sample.shift_id)
            };
        }
        const shiftStats = shiftStatList[sample.shift_id];
        if (shiftStats.machines[machineId] == undefined) {
            const machine = machineList.find(m => m.id == machineId);
            shiftStats.machines[machineId] = machine;
        }
        shiftStats.units += sample.units;
    });

    // Se resta desperdicios de estadisticas por turno
    Object.keys(shiftStatList).forEach(shift_id => {
        shiftStatList[shift_id].units -= wasteList.filter(waste => waste.shift_id == shift_id)
                                        .reduce((prev, curr) =>{
                                            const productSessions = _.get(curr, 'ProductSessions', []);
                                            const qualities: any = _.flatten(productSessions.map(p=>_.get(p, 'Qualities', []))).filter((q: any)=>q.qty!=null)
                                            return prev + qualities.reduce((prevq, currq) => prevq + currq.qty)
                                        }, 0);
    });

    shiftList.forEach(shift => {
        const shiftStats = shiftStatList[shift.id];
        if (shiftStats == undefined) { return; }
        const machinesInShift = shiftStats.machines;
        const shiftMaxVel = machineGroupMaxVel(machinesInShift);
        const elapsedTime = shiftElapsedTime(shift); // Tiempo transcurrido en minutos
        const shiftCurrentMaxAccumulated = shiftCurrentMaxAccum(shift, machinesInShift); // vel max se asume en minutos
        const shiftCurrentPerformance_ = shiftCurrentPerformance(shift.units, shift, machinesInShift);
        const partialElapsedMinutes = shiftPartialElapsedTime(shift);
        const partialMaxAccumulated = shiftPartialMaxAccum(shift, machinesInShift); // shiftMaxVel * partialElapsedMinutes; //vel max se asume en minutos
        const partialPerformance = shiftPartialPerformance(shift.units, shift, machinesInShift); // shiftStats.units / partialMaxAccumulated * 100;
        shiftStats.maxVel = shiftMaxVel;
        shiftStats.elapsedTime = elapsedTime;
        shiftStats.partialElapsedTime = partialElapsedMinutes;
        shiftStats.maxProduction = shiftCurrentMaxAccumulated;
        shiftStats.partialMaxProduction = partialMaxAccumulated;
        shiftStats.performance = shiftCurrentPerformance_;
        shiftStats.partialPerformance = partialPerformance;
    });

    return shiftStatList;
}

export function statsPerMachineSeveralDays(samples: Sample[], machineList: any[], shiftSessionList: any[], wasteList: any[], options = {}): MachineStatsObj {
	samples = sortSamples(samples);
	const dayStr = (sample: Sample) => new Date(sample.units_time).toLocaleDateString('es-CL');
	const samplesPerDay = _.groupBy(samples, dayStr);
	let acumStatsPerMachine: MachineStatsObj;
	const ndays = _.keys(samplesPerDay).length;
	for (const day of _.keys(samplesPerDay)) {
		const daySamples = samplesPerDay[day];
		const stats = statsPerMachine(daySamples, machineList, shiftSessionList, wasteList, options);

		if (_.isNil(acumStatsPerMachine)) {
			acumStatsPerMachine = JSON.parse(JSON.stringify(stats));
		} else {
			// machineStats.maxVel                     = stats.maxVel;
			for (const machine of machineList) {
				const machineSamples = daySamples.filter(s => s.machine_id === machine.id);
				const machineStats: MachineStatsInterface = acumStatsPerMachine[machine.id];
                if(machineStats === undefined){
                    console.error(`No existen estadisticas acumuladas para máquina (${machine.id}) ${machine.name}  iiot code: ${machine.iiot_code}. Se presume que no existen datos para la maquina y por eso no hay estadisticas. MachineStats: `, acumStatsPerMachine)
                    continue;
                }
				const newMachineStats: MachineStatsInterface = stats[machine.id];
				if (_.isNil(newMachineStats)) { continue; }
				/*console.log(`Tiempo detenido dia ${dayStr(daySamples[0])} maquina ${machineToString(machine)}: ${newMachineStats.stoppedTime} (${newMachineStats.stoppedMinutes} minutos)
				 Nuevo tiempo detenido: ${machineStats.stoppedMinutes + newMachineStats.stoppedMinutes} minutos`)*/
				machineStats.units 											+= newMachineStats.units;
				machineStats.elapsedMinutes 						+= newMachineStats.elapsedMinutes;
				machineStats.partialElapsedMinutes 			+= newMachineStats.partialElapsedMinutes;
				machineStats.currentMaxProduction 			+= newMachineStats.currentMaxProduction;
				machineStats.partialMaxProduction 			+= newMachineStats.partialMaxProduction;
				machineStats.performance 								+= newMachineStats.performance / ndays; // *
				machineStats.partialPerformance 				+= newMachineStats.partialPerformance / ndays; // *
				machineStats.productionMinutes 					+= newMachineStats.productionMinutes;
				machineStats.productionTime 						= minutesToStr(machineStats.productionMinutes);
				machineStats.stoppedMinutes 						+= newMachineStats.stoppedMinutes;
				machineStats.stoppedTime 								= minutesToStr(machineStats.stoppedMinutes);
				machineStats.stoppedPercentStr 					= `${calcPercent(machineStats.stoppedMinutes, machineStats.partialElapsedMinutes) * 100}`;
				machineStats.effectivePercentStr 				= `${calcPercent(machineStats.productionMinutes, machineStats.partialElapsedMinutes) * 100}`;
				machineStats.shiftDuration 							+= newMachineStats.shiftDuration;
				machineStats.shiftPartialDuration 			+= newMachineStats.shiftPartialDuration;
				machineStats.meanVel 										+= newMachineStats.meanVel / ndays; // *
				machineStats.expectedMeanVelAccumulated += newMachineStats.expectedMeanVelAccumulated;
				machineStats.expectedVelAccumulated 		+= newMachineStats.expectedVelAccumulated;
				machineStats.samples 										= machineStats.samples.concat(newMachineStats.samples);
				/*console.log(`New statistics for day ${day} ${machineToString(machine)}:
					${machineStatsToString(machineStats)}
					${samplesToString(machineSamples)}
				`)*/
				// console.log(`
				// 	Accumulated statistics for ${machineToString(machine)}:
				// 	${machineStatsToString(machineStats)}
				// 	${samplesToString(machineSamples)}
				// `);
			}
		}
	}
	return acumStatsPerMachine;
}

export function samplesWithinShift(samples: Sample[], shift: any): Sample[] {
    return samples.filter(sample=>
        sample.shift_id === shift.id && inShiftBounds(shift, new Date(sample.timestamp))
    )
}

export function samplesWithinShiftSession(samples: Sample[], shiftSession: any): Sample[] {
    // console.log(`[samples within shift session] stest Se eliminan muestras. Sesion: machine ${shiftSession.machine_id} shift ${shiftSession.shift_id} De: ${shiftSession.real_start} a ${shiftSession.real_end}`, samples.filter(sample=>
    //     !(Number(sample.shift_id) == Number(shiftSession.shift_id) &&
    //     Number(sample.machine_id) == Number(shiftSession.machine_id)) //&&
    //     // inShiftSessionBounds(shiftSession, new Date(sample.timestamp)))
    // ))
    return samples.filter(sample=>
        Number(sample.shift_id) == Number(shiftSession.shift_id) &&
        Number(sample.machine_id) == Number(shiftSession.machine_id) &&
        inShiftSessionBounds(shiftSession, new Date(sample.timestamp))
    )
}

/*
Calcula estadisticas por máquina
Se asume que no hay overlapping en turnos
Esto solo sirve para data del mismo dia
*/
export function statsPerMachine(samples: Sample[], machineList: any[], shiftSessionList: any[], wasteList: any[], options = {}): MachineStatsObj {
	const referenceDate = _.get(options, 'ignoreTime', false) ? null : new Date();
    const {minSt, maxEt} = getShiftSessionsTimeBounds(shiftSessionList);
    const delimiters = _.get(options, 'delimiters', {st: minSt, et: maxEt});
	const machineStatsObj: MachineStatsObj = {};
	samples = sortSamples(samples);
	samples.forEach(sample => {
      const shiftId = sample.shift_id;
      const machineId = sample.machine_id;
      if (machineId == undefined) {
          return;
      }
      if (shiftId == undefined || !shiftSessionList.some(ss =>
          ss.shift_id == shiftId &&
          ss.machine_id == machineId &&
          inShiftSessionBounds(ss, new Date(sample.timestamp))
      )) {
          return;
      }
      if (machineStatsObj[machineId] == undefined) {
          machineStatsObj[machineId] = new MachineStats();
          machineStatsObj[machineId].machine = machineList.find(s => s.id == machineId);
      }
      const machineStats = machineStatsObj[machineId];
      if (machineStats.shifts[shiftId] == undefined) {
          const shiftSession = shiftSessionList.find(ss => ss.shift_id == shiftId && ss.machine_id == machineId);
          if (shiftSession) {
              const shift = shiftSession.Shift;
              if (shift != undefined) {
                  machineStats.shifts[shiftId] = shift;
              }
          }
      }
      machineStats.units += sample.units;
      machineStats.samples.push(sample);
      machineStats.vel = sample.units;
  });

    Object.keys(machineStatsObj).forEach((machine_id: string) => {
        const machineWasteList = wasteList.filter(waste => waste.machine_id == machine_id);
        if (machineWasteList.length > 0) {
            machineWasteList.forEach(waste => {
                const productSessions = _.get(waste, 'ProductSessions', []);
                const qualities: any = _.flatten(productSessions.map(p=>_.get(p, 'Qualities', []))).filter((q: any)=>q.qty!=null)
                if (qualities && qualities.length > 0) {
                    machineStatsObj[machine_id].units -= qualities.reduce((prevq, currq) => prevq + currq.qty);
                }
            });
        }
  });

 machineList.forEach(machine => {
			const machineStats = machineStatsObj[machine.id];
			if (machineStats == undefined) { return; }
			const machineSamples: Sample[] = machineStats.samples;
			const shiftSessions = asList(shiftSessionList.filter(ss => ss.machine_id == machine.id));
			if (shiftSessions.length === 0) {
                delete machineStatsObj[machine.id];
                return; 
            }
			const machineMaxVel = parseInt(machine.vel_max || 0);

            const getReferenceDate = (shift: any) => {
                const shiftSamples = samplesWithinShift(machineSamples, shift);
                if(shiftSamples.length === 0) return referenceDate || shift.et;
                return referenceDate || generateReferenceDate(shift, shiftSamples.slice(-1)[0]);
            }

            const shiftSessionElapsedTime_ = (shiftSession: any) => {
                const shift = shiftSession.Shift;
                
                if (!shift) return 0;
                let {st, et} = getShiftSessionTimeBounds(shiftSession);
                let delimited = limitTo(st, et, delimiters.st, delimiters.et);
                shift.st = delimited.st;
                shift.et = delimited.et;
                let sessionReferenceDate = getReferenceDate(shift);
                if (sessionReferenceDate && et && sessionReferenceDate > et) {
                    sessionReferenceDate = et;
                }

                let partialShift = _.cloneDeep(shift);
                if(isFromPreviousDayShiftSession(shiftSession, sessionReferenceDate)) {
                    partialShift.st = new Date(sessionReferenceDate);
                    partialShift.st.setHours(0, 0, 0, 0);
                    partialShift.shift_duration_minutes = (partialShift.et.getTime() - partialShift.st.getTime())/ 1000 / 60;
                    partialShift.collation_time_minutes = (partialShift.shift_duration_minutes / shift.shift_duration_minutes) * shift.collation_time_minutes;
                } else if(partialShift.st.getDate() != partialShift.et.getDate()) {
                    partialShift.et = new Date(partialShift.st);
                    partialShift.et.setHours(23, 59, 59, 999);
                    partialShift.shift_duration_minutes = (partialShift.et.getTime() - partialShift.st.getTime())/ 1000 / 60;
                    partialShift.collation_time_minutes = (partialShift.shift_duration_minutes / shift.shift_duration_minutes) * shift.collation_time_minutes;
                }
                // console.log('[shift session elapsed time] stest',{
                //     machine: shiftSession.machine_id,
                //     shift: shiftSession.shift_id,
                //     st: shift.st,
                //     et: shift.et,
                //     sessionReferenceDate,
                //     elapsed: shiftElapsedTime(partialShift, sessionReferenceDate)
                // });
                return shiftElapsedTime(partialShift, sessionReferenceDate);
            }

            const shiftSessionPartialElapsedTime_ = (shiftSession: any) => {
                const shift = shiftSession.Shift;
                if (!shift) return 0;
                const {st, et} = getShiftSessionTimeBounds(shiftSession);
                let delimited = limitTo(st, et, delimiters.st, delimiters.et);
                shift.st = delimited.st;
                shift.et = delimited.et;
                let sessionReferenceDate = getReferenceDate(shift);
                if (sessionReferenceDate && et && sessionReferenceDate > et) {
                    sessionReferenceDate = et;
                }
                let partialShift = _.cloneDeep(shift);
                if(isFromPreviousDayShiftSession(shiftSession, sessionReferenceDate)) {
                    partialShift.st = new Date(sessionReferenceDate);
                    partialShift.st.setHours(0, 0, 0, 0);
                    partialShift.shift_duration_minutes = (partialShift.et.getTime() - partialShift.st.getTime())/ 1000 / 60;
                    partialShift.collation_time_minutes = (partialShift.shift_duration_minutes / shift.shift_duration_minutes) * shift.collation_time_minutes;
                } else if(partialShift.st.getDate() != partialShift.et.getDate()) {
                    partialShift.et = new Date(partialShift.st);
                    partialShift.et.setHours(23, 59, 59, 999);
                    partialShift.shift_duration_minutes = (partialShift.et.getTime() - partialShift.st.getTime())/ 1000 / 60;
                    partialShift.collation_time_minutes = (partialShift.shift_duration_minutes / shift.shift_duration_minutes) * shift.collation_time_minutes;
                }
                return shiftPartialElapsedTime(partialShift, sessionReferenceDate);
            }

            const shiftSessionPartialDuration_ = (shiftSession: any) => {
                const shift = shiftSession.Shift;
                if (!shift) return 0;
                const {st, et} = getShiftSessionTimeBounds(shiftSession);
                let delimited = limitTo(st, et, delimiters.st, delimiters.et);
                shift.st = delimited.st;
                shift.et = delimited.et;
                const referenceDate = getReferenceDate(shift);
                let partialShift = _.cloneDeep(shift);
                if (isFromPreviousDayShiftSession(shiftSession, referenceDate)) {
                    partialShift.st = new Date(referenceDate);
                    partialShift.st.setHours(0, 0, 0, 0);
                    partialShift.shift_duration_minutes = (partialShift.et.getTime() - partialShift.st.getTime())/ 1000 / 60;
                    partialShift.collation_time_minutes = (partialShift.shift_duration_minutes / shift.shift_duration_minutes) * shift.collation_time_minutes;
                } else if(partialShift.st.getDate() != partialShift.et.getDate()) {
                    partialShift.et = new Date(partialShift.st);
                    partialShift.et.setHours(23, 59, 59, 999);
                    partialShift.shift_duration_minutes = (partialShift.et.getTime() - partialShift.st.getTime())/ 1000 / 60;
                    partialShift.collation_time_minutes = (partialShift.shift_duration_minutes / shift.shift_duration_minutes) * shift.collation_time_minutes;
                }
                return shiftPartialDuration(partialShift);
            }

			const elapsedMinutes                				= shiftSessions.reduce((prev, shiftSession) => prev + shiftSessionElapsedTime_(shiftSession), 0);
			const partialElapsedMinutes         				= shiftSessions.reduce((prev, shiftSession) => prev + shiftSessionPartialElapsedTime_(shiftSession), 0);
			const machineCurrentMaxAccum        = currentMaxAccum(machineMaxVel, elapsedMinutes);
			const machinePartialMaxAccumulated  = currentMaxAccum(machineMaxVel, partialElapsedMinutes);
			const productionMinutes             = calcWorkedMinutes(machineSamples);
			const productionPercent                 = calcPercent(productionMinutes, partialElapsedMinutes);
			let stoppedMinutes                  = effectiveTime((1 - productionPercent), partialElapsedMinutes);
			if (stoppedMinutes < 0) { stoppedMinutes = 0; }
			const partialDuration               				= shiftSessions.reduce((prev, shiftSession) => prev + shiftSessionPartialDuration_(shiftSession), 0);
			const duration                      				= shiftSessions.reduce((prev, shiftSession) => prev + shiftSessionElapsedTime_(shiftSession), 0);
			const machinePartialPerformance     = performance(productionMinutes, partialElapsedMinutes);
			const machinePerformance            = performance(productionMinutes, duration);

			machineStats.maxVel                     = machineMaxVel;
			machineStats.elapsedMinutes             = elapsedMinutes;
			machineStats.partialElapsedMinutes      = partialElapsedMinutes;
			machineStats.currentMaxProduction       = machineCurrentMaxAccum;
			machineStats.partialMaxProduction       = machinePartialMaxAccumulated;
			machineStats.performance                = machinePerformance;
			machineStats.partialPerformance         = machinePartialPerformance;
			machineStats.productionMinutes          = productionMinutes;
			machineStats.productionTime             = minutesToStr(machineStats.productionMinutes);
			machineStats.stoppedMinutes             = stoppedMinutes;
			machineStats.stoppedTime                = minutesToStr(machineStats.stoppedMinutes);
			machineStats.stoppedPercentStr          = `${calcPercent(machineStats.stoppedMinutes, machineStats.partialElapsedMinutes) * 100}`;
			machineStats.effectivePercentStr        = `${calcPercent(machineStats.productionMinutes, machineStats.partialElapsedMinutes) * 100}`;
			machineStats.shiftDuration              = duration;
			machineStats.shiftPartialDuration       = partialDuration;
			machineStats.meanVel                    = (isNaN(machineStats.partialElapsedMinutes) ||  machineStats.partialElapsedMinutes == 0)? 0 : machineStats.units / Number(machineStats.partialElapsedMinutes);
			machineStats.expectedMeanVelAccumulated = calcExpectedAccumulated(machineStats.units, machineStats.meanVel, machineStats.shiftPartialDuration - machineStats.partialElapsedMinutes);
			machineStats.expectedVelAccumulated     = calcExpectedAccumulated(machineStats.units, machineStats.vel, machineStats.shiftPartialDuration - machineStats.partialElapsedMinutes);
			machineStats.packagingUnit              = getPackageUnit(machine);
			});

 return machineStatsObj;
}

function fixShiftDatesToLastTS(shift: any, samples: Sample[]){
    const shiftSamples = samples.filter(s=>s.shift_id === shift.id && inShiftBounds(shift, new Date(s.timestamp)));
    if(shiftSamples.length === 0) return;
    const lastSample = (shiftSamples.slice(-1)[0])
    const lastTimestamp = lastSample.timestamp;
    const firstSample = shiftSamples[0];
    // const firstTimestamp = firstSample.timestamp;
    const etTimeBounds = getShiftTimeBoundsByTimestamp(shift, new Date(lastTimestamp))
    // const stTimeBounds = getShiftTimeBoundsByTimestamp(shift, new Date(firstTimestamp))
    if(etTimeBounds === null){
        console.error(`fixShiftDatesToLastTS No se pudo obtener los limites temporales para los siguientes datos: `, {shift, samples, lastSample, firstSample, etTimeBounds})
        return;
    }
    shift.st = etTimeBounds.st;
    shift.et = etTimeBounds.et;
}

function machineStatsToString(machineStats: MachineStats) {
	return `Tiempo producido: ${machineStats.productionMinutes} minutos => ${machineStats.productionTime}.
				Tiempo detenida: ${machineStats.stoppedMinutes} minutos => ${machineStats.stoppedTime}.
				Tiempo parcial: ${machineStats.partialElapsedMinutes} minutos.
				Duración parcial turno: ${machineStats.shiftPartialDuration} minutos.
				Efectividad: ${machineStats.effectivePercentStr}%.
				Max vel: ${machineStats.maxVel}.
				Velocidad media: ${machineStats.meanVel}.
				Velocidad actual: ${machineStats.vel}.
				Duración parcial del turno: ${machineStats.shiftPartialDuration} minutos.
				Acumulado esperado: ${machineStats.expectedMeanVelAccumulated}.
				Acumulado a velocidad actual: ${machineStats.expectedVelAccumulated}.
				Unidades: ${machineStats.units}.`;
}

function machineToString(machine) {
	return `${machine.name}(${machine.id})`;
}

function samplesToString(samples: Sample[]) {
	return `Calculo de minutos simple: ${samples.filter(s => s.units != 0).length}.
				Muestras en cero: ${samples.filter(s => s.units === 0).length}.
				Muestras. ${samples.length}`;
}

function shiftToString(shift) {
	// console.log('shift: ', shift);
	return `Turno ${shift.name} ${shift.name} (${_.get(shift, 'ShiftType.name', shift.shift_type_name)}). De ${String(shift.start_time_day_label).padStart(2, '0')} a ${String(shift.end_time_day_label).padStart(2, '0')} de ${String(shift.start_time_hour).padStart(2, '0')}:${String(shift.start_time_minute).padStart(2, '0')} a ${String(shift.end_time_hour).padStart(2, '0')}:${String(shift.end_time_minute).padStart(2, '0')}`;
}

function shiftsToString(shiftList: any[]) {
	if (_.isNil(shiftList) || _.isEmpty(shiftList)) { return 'Sin turnos'; }
	return shiftList.reduce((prev, curr) => prev + '\n*' + shiftToString(curr)
		, 'Turnos:\n-----------------------');
}

// /*
// Recalcula estadisticas considerando muestra instantanea.
// Realiza conversion de unidades OJO
// */
// export function setMachineStatsInstantSample(machineStats:MachineStats, sample:Sample){
//     machineStats.vel                        = convertSampleUnit(sample, machineStats.machine);
//     machineStats.expectedVelAccumulated     = calcExpectedAccumulated(machineStats.vel, machineStats.shiftPartialDuration);
// }

/*
Calcula el acumulado esperado pasado x cantidad de minutos
*/
function calcExpectedAccumulated(acum: number, vel: number, elapsedMinutes: number): number {
    return vel * elapsedMinutes + acum;
}

/*
Calcula tiempo efectivo en minutos
*/
function effectiveTime(effectiveness: number, elapsedMinutes: number): number {
    return effectiveness * elapsedMinutes;
}

/*
Calcula efectividad
La efectividad es el porcentaje de tiempo producido
*/
function calcPercent(value: number, total: number): number {
    if (total === 0) {
        return 0; // O algún otro valor por defecto, dependiendo de la lógica de negocio
    }
    return value / total;
}

export function asList(obj) {
    return Object.keys(obj).map((key) => _.cloneDeep(obj[key]));
}

/*
Obtiene estadisticas de la planta
*/
export function calcPlantStats(statsPerMachine_: MachineStatsObj): PlantStats {
    const machineList = Object.keys(statsPerMachine_).map((machineId) => statsPerMachine_[machineId].machine);
    const plantStats = new PlantStats();
    const thereIsAProductionLine_ = thereIsAProductionLine(machineList);
    const outMachineList = getLastInProductionLine(machineList);
    asList(statsPerMachine_).forEach((stats: MachineStats) => {
        const machine = stats.machine;
        if (!thereIsAProductionLine_ || isLastInProductionLine(machine)) {
            plantStats.accumulated 									+= stats.units;
            plantStats.elapsedMinutes               += stats.elapsedMinutes;
            plantStats.partialElapsedMinutes        += stats.partialElapsedMinutes;
            plantStats.currentMaxProduction         += stats.currentMaxProduction;
            plantStats.partialMaxProduction         += stats.partialMaxProduction;
            plantStats.performance                  += stats.performance;
            plantStats.partialPerformance           += stats.partialPerformance;
            plantStats.productionMinutes            += stats.productionMinutes;
            plantStats.stoppedMinutes               += stats.stoppedMinutes;
            plantStats.shiftDuration                += stats.shiftDuration;
            plantStats.shiftPartialDuration         += stats.shiftPartialDuration;
            plantStats.expectedMeanVelAccumulated   += stats.expectedMeanVelAccumulated;
            plantStats.expectedVelAccumulated       += stats.expectedVelAccumulated;
            plantStats.vel                          += stats.vel;
            plantStats.meanVel                      += stats.meanVel;
        }

        if (thereIsAProductionLine_) {
            if (isLastInProductionLine(machine)) {
                plantStats.outputPlantAccumulated += stats.units;
            } else {
                plantStats.entryPlantAccumulated += stats.units;
            }
        }
    });
    if (machineList.length > 0) {
        plantStats.elapsedMinutes           /= machineList.length;
        plantStats.partialElapsedMinutes    /= machineList.length;
        plantStats.performance              /= machineList.length;
        plantStats.partialPerformance       /= machineList.length;
        plantStats.productionMinutes        /= machineList.length;
        plantStats.stoppedMinutes           /= machineList.length;
        plantStats.shiftDuration            /= machineList.length;
        plantStats.shiftPartialDuration     /= machineList.length;
        plantStats.vel                      /= machineList.length;
        plantStats.meanVel                  /= machineList.length;
        plantStats.productionTime           = minutesToStr(plantStats.productionMinutes);
        plantStats.stoppedTime              = minutesToStr(plantStats.stoppedMinutes);
        plantStats.stoppedPercentStr        = `${calcPercent(plantStats.stoppedMinutes, plantStats.partialElapsedMinutes) * 100}`;
        plantStats.effectivePercentStr      = `${calcPercent(plantStats.productionMinutes, plantStats.partialElapsedMinutes) * 100}`;
        const plantPerformance = performance(plantStats.accumulated, plantStats.partialMaxProduction);
        // console.log(`MachineList performance: ${plantStats.partialPerformance} calculated plant performance: ${plantPerformance}`)
        plantStats.outMachineList = outMachineList;
    }
    return plantStats;
}

function dateToTimeStr(date: Date) {
    const minutes = date.getMinutes();
    const hour = date.getHours();
    return minutesToStr(hour * 60 + minutes);
}

export function generateDataset(series: any[], xTickLabels: any[]) {
    return {
        series,
        xTickLabels
    };
}

export function generateXTickLabels(samples: Sample[]) {
    samples = fixGaps(samples);
    const firstSample = samples[samples.length - 1];
    const sensorData = samples.filter(sample => sample.sensor_id == firstSample.sensor_id);
    return sensorData.map((sample: Sample) => new Date(sample.timestamp));
}

export function generateDatasetSerie(samples: Sample[], options: any = {}) {
		samples = fixGaps(samples);
  return {
        name: options && options.name ? options.name : 'Planta',
        data: samples.map((sample: Sample) => Math.round(sample.units * 100) / 100),
        type: SERIE_TYPE.LINE,
        strokeWidth: 3
        // series: samples.map((sample:Sample) => {
        //   return {
        //     name: new Date(sample.timestamp),
        //     value: Math.round(sample.units * 100) / 100,
        //     tooltipText: [`${dateToTimeStr(new Date(sample.timestamp))} | ` + (options && options.name ? options.name : `Planta`) + `: ${Math.round(sample.units * 100) / 100} ${options && options.units ? options.units : ''}`],
        //   }
        // })
    };
}

export function generateSensorsDatasetSeries(samples: Sample[], machine: any) {
    const series = [];
    // let xTickLabels = null;
    machine.Machine2Sensors.forEach(sensor => {
        let sensorData: Sample[] = samples.filter((sample: Sample) => sample.sensor_id == sensor.id);
				    sensorData = fixGaps(sensorData);
        // if(xTickLabels == null) xTickLabels = generateXTickLabels(sensorData);
        const serie = generateDatasetSerie(sensorData, {
          name: `${machine.name} - ${_.get(sensor, 'MachineSensor.name', sensor.MachineTechType.name)}`,
          units: _.get(machine, 'Products[0].PackageUnit.name', 'un')
        });
        if (serie) { series.push(serie); }
    });
    return series;
}

export function generateULineDataset(samples: Sample[], options = {}) {
		samples = fixGaps(samples);
  const generator = _.get(options, 'colorGenerator', colorGenerator());
  const samplesByMachine = _.groupBy(samples, 'machine_id');
  const series = Object.keys(samplesByMachine).map(machineId => {
        const formatter = _.get(options, 'formatter', (machineId) => `${machineId}`);
				    const samples = samplesByMachine[machineId];
        return {
            data: samples.map(sample => sample.units),
            label: formatter(machineId),
            stroke: generator.generate()
        };
    });
		const firstSamples = samplesByMachine[Object.keys(samplesByMachine)[0]];
		// console.log("gtest first machine samples", firstSamples)
  const dateList = firstSamples.map(sample => new Date(sample.timestamp));
		// console.log("gtest dateList: ", dateList)
  const xTicks = mapToUnixTime(dateList);
  const axes = [];
  return {series, xTicks, axes};
}

export function generateSensorsULineDataset(samples: Sample[], machine, options = {}) {
			samples = fixGaps(samples);
   const generator = _.get(options, 'colorGenerator', colorGenerator());
    // const samplesByMachine = _.groupBy(samples, 'machine_id');
   samples = samples.filter(sample => sample.machine_id == machine.id);
   let firstSensorSamples = [];
   const series = machine.Machine2Sensors.map(sensor => {
        const sensorSamples: Sample[] = samples.filter(sample => sample.sensor_id == sensor.id);
        if (firstSensorSamples.length == 0) { firstSensorSamples = sensorSamples; }
        const formatter = _.get(options, 'formatter', (machine, sensor) => `${machine.name} - ${_.get(sensor, 'MachineSensor.name', sensor.MachineTechType.name)}`);
        const sensorSerie = {
            data: sensorSamples.map(sample => sample.units),
            label: formatter(machine, sensor),
            stroke: generator.generate()
        };
        return sensorSerie;
    });

   const dateList = firstSensorSamples.map(sample => new Date(sample.timestamp));
   const xTicks = mapToUnixTime(dateList);
   const axes = [];
   return {series, xTicks, axes};
}

export function mapToUnixTime(dateList: Date[]) {
    return dateList.map((date) => Math.round(date.getTime() / 1000));
}

export function groupSamplesByMachineId(samples: Sample[]) {
    samples = sortSamples(samples);
    const samplesPerMachineObj = {};
    samples.forEach((sample: Sample) => {
        const machineId = sample.machine_id;
        if (samplesPerMachineObj[machineId] == undefined) {
            samplesPerMachineObj[machineId] = [];
        }
        samplesPerMachineObj[machineId].push(sample);
    });
    return samplesPerMachineObj;
}

export function sortSamples(samples: Sample[]) {
    // Se ordena por fecha
    return samples.sort((x, y) => new Date(x.timestamp).getTime() - new Date(y.timestamp).getTime());
}

export function limitShiftsTimeRange(shiftList: any[], st: Date, et: Date) {
    const st_ = st.getTime();
    const et_ = et.getTime();
    return shiftList
        .filter(shift => {
            const shiftSt = shift.st.getTime();
            const shiftEt = shift.et.getTime();
            if (shiftEt < st_) {
                return false;
            }
            if (shiftSt > et_) {
                return false;
            }
            return true;
        })
        .map(shift => {
            const shiftSt = shift.st.getTime();
            const shiftEt = shift.et.getTime();
            if (shiftSt < st_) {
                shift = Object.assign({}, shift, {st});
            }
            if (shiftEt > et_) {
                shift = Object.assign({}, shift, {et});
            }
            return Object.assign({}, shift);
        });
}

/*
Calcula la cantidad de minutos trabajados dada una lista de
mediciones
*/
export function calcWorkedMinutes(samples: Sample[], threshold = 10): number {
    if (!samples || samples.length == 0) {
      return 0;
    }

    samples = sortSamples(samples);

    let workedMinutes = 0;

    let prevDate = null;
    let prevSampleDate = null;

    for (const sample of samples) {
      const currentDate = new Date(sample.timestamp);


      if (prevSampleDate == null) {

        prevSampleDate = currentDate;
      }
      const minutes = (currentDate.getTime() - prevSampleDate.getTime()) / 1000 / 60;
			// console.log(`atest ${minutes} minutes from ${currentDate.toLocaleString('sv')} to ${prevSampleDate.toLocaleString('sv')}`);

      prevSampleDate = currentDate;

      if (sample.units != 0) {
        if (prevDate == null) {
          prevDate = currentDate;
        }
				    if (minutes > 0 && minutes < threshold) {
        	workedMinutes += minutes;
					//    console.log(`atest se suman ${minutes} quedando en ${workedMinutes} fecha ${currentDate.toLocaleString('sv')}`);
				}
      }
      prevDate = currentDate;
    }
    return workedMinutes;
}

/*
Coloca un cero en cada extremo de cada gap para evitar que aparezcan lineas rectas en el grafico
threshold: cantidad de minutos minimo de gap
*/
export function fixGaps(samples: Sample[], threshold = 10): Sample[] {
	if (threshold < 3) { threshold = 3; }
	if (!samples || samples.length == 0) {
		return [];
	}
	const samples_ = Array.from(sortSamples(samples));
	const samplesPerSensor = _.groupBy(samples, 'sensor_id');
	// console.log("running fix gaps...", samplesPerSensor)

	const gaps = findGaps(samples, threshold);
	// console.log("gtest gaps encontrados: ", gaps)
	for (const sensor_id of _.keys(samplesPerSensor)) {
		const samples = samplesPerSensor[sensor_id];

		for (const gap of gaps) {
			const sample = samples[0];
			//console.log('gtest se añade 0 en los extremos', {gap, sample, sensor_id});
			const stGap = new Date(gap[0]);
			const etGap = new Date(gap[1]);
			stGap.setMinutes(stGap.getMinutes() + 1);
			etGap.setMinutes(etGap.getMinutes() - 1);
			samples_.push({
				timestamp: String(stGap),
				units_time: stGap.toISOString(),
				units: 0,
				machine_id: sample.machine_id,
				sensor_id: sample.sensor_id,
				shift_id: sample.shift_id,
				company_id: sample.company_id
			});
			samples_.push({
				timestamp: String(etGap),
				units_time: etGap.toISOString(),
				units: 0,
				machine_id: sample.machine_id,
				sensor_id: sample.sensor_id,
				shift_id: sample.shift_id,
				company_id: sample.company_id
			});
				/*console.log(`gtest Se encuentra gap entre ${stGap.toLocaleString('es-CL')} y ${etGap.toLocaleString('es-CL')}`, {
					stSample: {
						timestamp: String(stGap),
						units_time: stGap.toISOString(),
						units: 0,
						machine_id: sample.machine_id,
						sensor_id: sample.sensor_id,
						shift_id: sample.shift_id,
						company_id: sample.company_id
					},
					etSample:{
						timestamp: String(etGap),
						units_time: etGap.toISOString(),
						units: 0,
						machine_id: sample.machine_id,
						sensor_id: sample.sensor_id,
						shift_id: sample.shift_id,
					company_id: sample.company_id
					}
				})*/
		}
	}
	// console.log("gtest samples with gap fixeds for ploting: ", samples_)
	return sortSamples(samples_);
}

export function findGaps(samples: Sample[], threshold = 10): Sample[] {
	if (threshold < 3) { threshold = 3; }
	if (!samples || samples.length == 0) {
		return [];
	}
	const samples_ = Array.from(sortSamples(samples));
	const samplesPerSensor = _.groupBy(samples, 'sensor_id');
	// console.log("running fix gaps...", samplesPerSensor)

	let gaps = [];
	for (const sensor_id of _.keys(samplesPerSensor)) {
		const samples = samplesPerSensor[sensor_id];

		let prevSampleDate = null;
		let prevSample = null;

		for (const sample of samples) {
			const currentDate = new Date(sample.timestamp);


			if (prevSampleDate == null) {
				prevSampleDate = currentDate;
				prevSample = sample;
				continue;
			}
			const minutes = (currentDate.getTime() - prevSampleDate.getTime()) / 1000 / 60;

			if ((sample.units != 0 || prevSample.units != 0) && minutes > threshold &&
				sample.machine_id == prevSample.machine_id && sample.sensor_id == prevSample.sensor_id) {
				// console.log("gtest se añade 0 en los extremos")
				const stGap = new Date(prevSampleDate);
				const etGap = new Date(currentDate);
				gaps.push([stGap.toISOString(), etGap.toISOString()]);
			}
			prevSampleDate = currentDate;
			prevSample = sample;
		}
	}
	// console.log("gtest samples with gap fixeds for ploting: ", samples_)
	gaps = _.uniqWith(gaps, (gap1, gap2) => gap1[0] === gap2[0] && gap1[1] === gap2[1]);
	return gaps;
}

/*
	Se encarga de agregar muestras con cero cuando no existan datos para un determinado tiempo
	Esto se asegura de que en cada segundo exista una muestra para cada maquina sensor

	OJO: No verifica que el turno corresponda, esto es unicamente para graficar
 */
export function fillZeroOnNoSample(samples: Sample[]) {
	const samplesByDate = _.groupBy(samples, 'timestamp');
	const samplesBySensorId = _.groupBy(samples, 'sensor_id');
	const sensorIdList = _.keys(samplesBySensorId);
	for ( const date of _.keys(samplesByDate) ) {
		const dateSamples = samplesByDate[date];
		const noDataSensorIds = sensorIdList
			.filter(sensorId =>
				dateSamples.find(s => s.sensor_id === Number(sensorId)) === undefined);
		for ( const sensorId of noDataSensorIds ) {
			const newSample = _.cloneDeep(samplesBySensorId[sensorId][0]);
			newSample.timestamp = date;
			newSample.units_time = dateSamples[0].units_time;
			newSample.units = 0;
			samples.push(newSample);
		}
	}
}

/*
Rellena muestras inexistentes con cero en un turno determinado
Se asegura de tener al menos una muestra por minuto para cada sensor
Debe tener en cuenta que el primer dia no puede partir con el turno de fin (media noche)
*/
function fillShiftGaps(samples: Sample[], shift: any, st: Date, et: Date): Sample[] {
    const sensorIds = _.uniq(samples.map(sample => sample.sensor_id));
    const sensorSampleTemplates: {[sensorId: number]: Sample} = sensorIds.reduce((obj, sensorId)=>{
        obj[sensorId] = samples.find(s=>s.sensor_id === sensorId);
        return obj;
    },{})
    samples = samplesWithinShift(samples, shift);
    if (samples.length === 0) return samples;
    const samplesByTS = _.groupBy(samples, 'timestamp');
    const isFirstDay = (ts: number)=>{
        return new Date(ts).getDate() === st.getDate()
    }

    for(let ts = st.getTime(); ts <= et.getTime(); ts += 60 * 1000){
        if(inShiftBounds(shift, new Date(ts)) === false) continue;
        //Se asegura de eliminar las muestras de media noche del turno anterior al primer dia
        if(isFirstDay(ts) && isFromPreviousDayShift(shift, new Date(ts))){
            continue;
        }
        const m = moment(new Date(ts));
        const timestamp = m.format('YYYY-MM-DDTHH:mm:ss.SSSZ');
        if(samplesByTS[timestamp] === undefined){
            samplesByTS[timestamp] = _.values(sensorSampleTemplates).map(sample=>_.assignIn({}, sample, {
                timestamp: timestamp,
                units_time: timestamp,
                units: 0,
                shift_id: shift.id,
            }));
            continue;
        }
        const sensorIdsInTS = samplesByTS[timestamp].map(sample=>sample.sensor_id);
        sensorIds.forEach(sensorId=>{
            if(sensorIdsInTS.indexOf(sensorId) === -1){
                const sample = _.cloneDeep(sensorSampleTemplates[sensorId]);
                sample.timestamp = timestamp;
                sample.units_time = timestamp;
                sample.units = 0;
                sample.shift_id = shift.id;
                samplesByTS[timestamp].push(sample);
            }
        })
    }
    return sortSamples(_.flatten(_.values(samplesByTS)));
}

/*
Rellena muestras inexistentes con cero en un turno determinado
Se asegura de tener al menos una muestra por minuto para cada sensor
Debe tener en cuenta que el primer dia no puede partir con el turno de fin (media noche)
REQUIERE QUE EL CAMPO TIMESTAMP DE CADA SAMPLE ESTE EN FORMATO 'YYYY-MM-DDTHH:mm:ss.SSSZ'
*/
function fillShiftSessionGaps(samples: Sample[], shiftSession: any, st: Date, et: Date): Sample[] {
    samples = samplesWithinShiftSession(samples, shiftSession);
    if (samples.length === 0) return samples;

    const sensorIds = _.uniq(samples.map(sample => sample.sensor_id));
    const sensorSampleTemplates: {[sensorId: number]: Sample} = sensorIds.reduce((obj, sensorId)=>{
        obj[sensorId] = samples.find(s=>s.sensor_id === sensorId);
        return obj;
    },{})
    const samplesByTS = _.groupBy(samples, 'timestamp');

    for(let ts = st.getTime(); ts <= et.getTime(); ts += 60 * 1000){
        if(inShiftSessionBounds(shiftSession, new Date(ts)) === false) continue;

        const m = moment(new Date(ts));
        const timestamp = m.format('YYYY-MM-DDTHH:mm:ss.SSSZ');
        if(samplesByTS[timestamp] === undefined){
            samplesByTS[timestamp] = _.values(sensorSampleTemplates)
                .map(sample=>_.assignIn({}, sample, {
                    timestamp: timestamp,
                    units_time: timestamp,
                    units: 0,
                    shift_id: shiftSession.shift_id,
                    shift_session_id: shiftSession.id
                }));
            continue;
        }
        const sensorIdsInTS = samplesByTS[timestamp]
            .map(sample=>sample.sensor_id);
        sensorIds.forEach(sensorId=>{
            if(sensorIdsInTS.indexOf(sensorId) === -1){
                const sample = _.cloneDeep(sensorSampleTemplates[sensorId]);
                sample.timestamp = timestamp;
                sample.units_time = timestamp;
                sample.units = 0;
                sample.shift_session_id = shiftSession.id,
                sample.shift_id = shiftSession.shift_id;
                samplesByTS[timestamp].push(sample);
            }
        })
    }
    return sortSamples(_.flatten(_.values(samplesByTS)));
}

/*
Rellena de ceros cuando no existan muestras para un determinado tiempo.
Esto incluye el caso en que no existan muestras al final o al inicio del rango de tiempo.
Se limita al rango de tiempo definido como parametro y los turnos establecidos.
*/
export function fillGaps(samples: Sample[], st: Date, et: Date, shiftSessionList: any[]){
    if(samples.length === 0) return samples;
    samples = sortSamples(samples);
    samples = inTimeRange(samples, st, et);
    return sortSamples(_.flatten(shiftSessionList.map(ss => fillShiftSessionGaps(samples, ss, st, et))))
}

/*
Verifica si existe o no la muestra en el arreglo de muestras
Devuelve la muestra ya existente
*/
export function sampleAlreadyExists(sample: Sample, samples: Sample[]): Sample {
    for (let i = samples.length - 1; i >= 0; i--) {
        const ts2 = new Date(samples[i].timestamp);
        ts2.setSeconds(0);
        const ts = new Date(sample.timestamp);
        ts.setSeconds(0);

        if (ts2.getTime() == ts.getTime() && samples[i].machine_id == sample.machine_id) {
            return samples[i];
        }
    }
    return null;
}

//Normaliza string ts a formato standard
export function normalizeTS(sample: Sample){
    sample.timestamp = moment(new Date(sample.timestamp)).format('YYYY-MM-DDTHH:mm:ss.SSSZ')
}

/*
Inserta o modifica una muestra
*/
export function pushOrUpdateSample(sample: Sample, samples: Sample[]): Sample[]{
    const existentSample = sampleAlreadyExists(sample, samples);
    if (existentSample) {
        // console.log("sample already exists: "); console.dir(sample);
        existentSample.units = sample.units;
    } else {
        // console.log("new sample!: "); console.dir(sample);
        samples.push(sample);
    }
    return samples;
}

/*
Inserta o modifica un arreglo muestras
*/
export function pushOrUpdateSamples(newSamples: Sample[], samples: Sample[]): Sample[] {
    newSamples.forEach((sample: Sample) => {
        samples = pushOrUpdateSample(sample, samples);
    });
    return samples;
}

/*
Indica si una maquina sensor es ON-OFF
*/
export function isOnOff(machine: any, sensor_rel_id: number): boolean {
    const machine2sensor = machine.Machine2Sensors.find(m2s => m2s.id == sensor_rel_id);
    return machine2sensor && machine2sensor.machine_tech_type_id == 5;
}

/*
Extrae producto
*/
export function getProduct(machine: any): any {
    return _.get(machine, 'Products[0]', null);
}

/*
Extrae unidad de medida
*/
export function getPackageUnit(machine: any): string {
    return _.get(machine, 'Products[0].PackageUnit.name', 'unidades');
}

/*
Estima rangos de tiempo eliminando overlaps
*/
function deleteOverlaps(dateRanges_: Date[][]) {
    const dateRanges = dateRanges_.map(row => Array.from(row));
    let anyOverlaping = true;
    while (anyOverlaping) {
        anyOverlaping = false;
        for (let i = 0; i < dateRanges.length; i++) {
            if (dateRanges[i] == null) { continue; }
            for (let j = i + 1; j < dateRanges.length; j++) {
                if (dateRanges[j] == null) { continue; }
                const st1 = dateRanges[i][0].getTime() / 1000 / 60;
                const et1 = dateRanges[i][1].getTime() / 1000 / 60;
                const st2 = dateRanges[j][0].getTime() / 1000 / 60;
                const et2 = dateRanges[j][1].getTime() / 1000 / 60;
                const c1 = st2 <= st1 && st1 <= et2;
                const c2 = st2 <= et1 && et1 <= et2;
                const c3 = et2 <= et1 && st2 >= st1;
                anyOverlaping = c1 || c2 || c3;
                if (c3) {
                    // se elimina dateRanges en indice j
                    dateRanges[j] = null;
                } else if (c1 && c2) {
                    // Se elimina dateRanges en indice i
                    dateRanges[i] = null;
                    break;
                } else if (c2) {
                    // Se debe forzar delimitar et1 = st2
                    dateRanges[i][1] = new Date(dateRanges[j][0]);
                    dateRanges[i][1].setMinutes(dateRanges[i][1].getMinutes() - 1);
                } else if (c1) {
                    // Se debe forzar delimitar st1 = et2
                    dateRanges[i][0] = dateRanges[j][1];
                    dateRanges[i][0].setMinutes(dateRanges[i][0].getMinutes() + 1);
                }
            }
        }
    }
    return dateRanges.filter(range => range != null);
}

function testDeleteOverlaps() {
    const dateRanges = [
        [new Date(2023, 1, 1, 10, 0, 0), new Date(2023, 1, 1, 11, 0, 0)],
        [new Date(2023, 1, 1, 10, 30, 0), new Date(2023, 1, 1, 11, 0, 0)],
        [new Date(2023, 1, 1, 10, 0, 0), new Date(2023, 1, 1, 11, 0, 0)],
        [new Date(2023, 1, 1, 9, 0, 0), new Date(2023, 1, 1, 10, 30, 0)],
        [new Date(2023, 1, 1, 9, 0, 0), new Date(2023, 1, 1, 12, 0, 0)],
        [new Date(2023, 1, 1, 11, 30, 0), new Date(2023, 1, 1, 14, 0, 0)],
    ];
    const dateRangesWO = deleteOverlaps(dateRanges);
    console.log('date ranges: '); console.dir(dateRanges);
    console.log('date ranges without overlapping: '); console.dir(dateRangesWO);
}

/*
Calcula minutos de trabajo evitando overlaping entre turnos
*/
export function shiftsMinutesWithoutOverlapping(shiftList) {
    let minutes = 0;
    let dateRanges = shiftList.map((shift) => [shift.st, shift.et]);
    dateRanges = deleteOverlaps(dateRanges);
    dateRanges.forEach(range => {
        minutes += (range[1].getTime() - range[0].getTime()) / 1000 / 60;
    });
    return minutes;
}

// Obtiene el procentaje de velocidad con respecto a velocidad máxima de la máquina seleccionada
export function velPercent(vel: number, machine: any) {
    const velPercent = vel * 100 / (machine.vel_max || 1);
    return velPercent;
}
